// extracted by mini-css-extract-plugin
export default {"overlay":"wB-z","bodyOpen":"xB-z","content":"yB-z","header":"zB-z","close":"AB-z","closeNoHeading":"BB-z"};